import { render, staticRenderFns } from "./OrderPageView.vue?vue&type=template&id=1285647e"
import script from "./OrderPageView.vue?vue&type=script&lang=js"
export * from "./OrderPageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports